import { createApp } from 'vue';
import store from '../store';
import { registerMaterialSymbol } from './registerMaterialSymbol';
import { mountRegisteredIslands } from './islandRegistry';

/**
 * Mounts detected page islands and the standalone map embed.
 * The package #app wrapper and its static Blade children stay unmanaged.
 *
 * @param {{ vuetify?: object|null, resolveVuetifyLocale?: Function, mountWithoutVuetify?: boolean }} context
 * @returns {string[]} island selectors scheduled on this call
 */
export function mountVueIslands(context = {}) {
    mountMapEmbed();
    return mountRegisteredIslands(context);
}

function mountMapEmbed() {
    const mapEmbedEl = document.getElementById('map-embed-app');
    if (!mapEmbedEl || mapEmbedEl.__cvIslandScheduled) return;

    mapEmbedEl.__cvIslandScheduled = true;
    const imageSrc = mapEmbedEl.getAttribute('data-image-src') || '';
    const caption = mapEmbedEl.getAttribute('data-caption') || '';

    import(/* webpackChunkName: 'map-popup' */ '../components/MapPopup.vue')
        .then(({ default: MapPopupRoot }) => {
            if (!mapEmbedEl.isConnected || mapEmbedEl.__vue_app__) return;
            const mapEmbedApp = createApp(MapPopupRoot, { imageSrc, caption, embedOnly: true });
            mapEmbedApp.use(store);
            registerMaterialSymbol(mapEmbedApp);
            mapEmbedApp.mount(mapEmbedEl);
        })
        .catch((err) => {
            mapEmbedEl.__cvIslandScheduled = false;
            if (typeof console !== 'undefined' && console.error) {
                console.error('[map-embed] load failed', err);
            }
        });
}
